import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Observable } from 'rxjs';
import { MatCardComponent } from '../../../material/src/matCard/matCard.component';
import { ComponentStyle } from '../abcComponent.model';
import { AbcComponentService } from '../abcComponent.service';
import { CardStyle, DocActionButton, ICard } from './abcCard';

@Component({
  selector: 'abcCard',
  template: `<ng-template #abcCard></ng-template>`,
  standalone: false,
})
export class AbcCardComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() searchInput: string;
  @Input() template: number;
  @Input() id: string;
  @ViewChild('abcCard', { static: true, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  @Output() onCardClick = new EventEmitter();
  @Output() onCardDblClick = new EventEmitter();
  @Output() onPrimaryActionClick = new EventEmitter();
  @Output() onSecondaryActionClick = new EventEmitter();
  @Output() onThirdActionClick = new EventEmitter();
  @Output() onFourthActionClick = new EventEmitter();
  @Output() onDocActionClick = new EventEmitter();
  style: ComponentStyle = ComponentStyle.Material;
  htmlAttributes: ICard;
  private componentRef;
  cartStyle: CardStyle;
  private eventListener = [];
  private _width: string | number;
  private _height: string | number;
  private _description: string;
  private _image: string;
  private _colorBar: string;
  private _leftIconPath: string;
  private _leftIsImg: boolean;
  private _rightIconSize: number;
  private _leftIconSize: number;
  private _leftIconPosition: number;
  private _rightIsImg: boolean;
  private _headerDescription: boolean;
  private _disabledTooltip: boolean;
  private _rightIconPath: string;
  private _defaultImg: string;
  private _shortHand: string;
  private _secondaryDisplayText: string;
  private _primaryActionName: string;
  private _secondaryActionName: string;
  private _thirdActionName: string;
  private _fourthActionName: string;
  private _icon: string;
  private _displayText: string;
  private _buttons: DocActionButton[];
  private _rtlEnabled: boolean;

  @Input()
  public get buttons() {
    return this._buttons;
  }
  public set buttons(data) {
    if (this.componentRef) {
      this.componentRef.buttons = data;
    }
    this._buttons = data;
  }
  private _class: string;

  @Input()
  get height() {
    return this._height;
  }
  set height(data: string | number) {
    this._height = data;
    if (this.componentRef) {
      this.componentRef.height = data;
    }
  }

  @Input()
  get rtlEnabled() {
    return this._rtlEnabled;
  }
  set rtlEnabled(data) {
    if (this.componentRef) {
      this.componentRef.rtlEnabled = data;
    }
    this._rtlEnabled = data;
  }

  @Input()
  get width() {
    return this._width;
  }
  set width(data) {
    if (this.componentRef) {
      this.componentRef.width = data;
    }
    this._width = data;
  }
  @Input()
  get displayText() {
    return this._displayText;
  }
  set displayText(data) {
    if (this.componentRef) {
      this.componentRef.displayText = data;
    }
    this._displayText = data;
  }
  @Input()
  get class() {
    return this._class;
  }
  set class(data) {
    if (this.componentRef) {
      this.componentRef.class = data;
    }
    this._class = data;
  }

  @Input()
  get icon() {
    return this._icon;
  }
  set icon(data) {
    if (this.componentRef) {
      this.componentRef.icon = data;
    }
    this._icon = data;
  }

  @Input()
  get headerDescription() {
    return this._headerDescription;
  }
  set headerDescription(data) {
    if (this.componentRef) {
      this.componentRef.headerDescription = data;
    }
    this._headerDescription = data;
  }

  @Input()
  get disabledTooltip() {
    return this._disabledTooltip;
  }
  set disabledTooltip(data) {
    if (this.componentRef) {
      this.componentRef.disabledTooltip = data;
    }
    this._disabledTooltip = data;
  }

  @Input()
  get secondaryDisplayText() {
    return this._secondaryDisplayText;
  }
  set secondaryDisplayText(data) {
    if (this.componentRef) {
      this.componentRef.secondaryDisplayText = data;
    }
    this._secondaryDisplayText = data;
  }

  @Input()
  get rightIconSize() {
    return this._rightIconSize;
  }
  set rightIconSize(data) {
    if (this.componentRef) {
      this.componentRef.rightIconSize = data;
    }
    this._rightIconSize = data;
  }

  @Input()
  get leftIsImg() {
    return this._leftIsImg;
  }
  set leftIsImg(data) {
    if (this.componentRef) {
      this.componentRef.leftIsImg = data;
    }
    this._leftIsImg = data;
  }

  @Input()
  get leftIconSize() {
    return this._leftIconSize;
  }
  set leftIconSize(data) {
    if (this.componentRef) {
      this.componentRef.leftIconSize = data;
    }
    this._leftIconSize = data;
  }

  @Input()
  get leftIconPosition() {
    return this._leftIconPosition;
  }
  set leftIconPosition(data) {
    if (this.componentRef) {
      this.componentRef.leftIconPosition = data;
    }
    this._leftIconPosition = data;
  }

  @Input()
  get rightIsImg() {
    return this._rightIsImg;
  }
  set rightIsImg(data) {
    if (this.componentRef) {
      this.componentRef.rightIsImg = data;
    }
    this._rightIsImg = data;
  }
  @Input()
  get rightIconPath() {
    return this._rightIconPath;
  }
  set rightIconPath(data) {
    if (this.componentRef) {
      this.componentRef.rightIconPath = data;
    }
    this._rightIconPath = data;
  }

  @Input()
  get defaultImg() {
    return this._defaultImg;
  }
  set defaultImg(data) {
    if (this.componentRef) {
      this.componentRef._defaultImg = data;
    }
    this._defaultImg = data;
  }

  @Input()
  get primaryActionName() {
    return this._primaryActionName;
  }
  set primaryActionName(data) {
    if (this.componentRef) {
      this.componentRef.primaryActionName = data;
    }
    this._primaryActionName = data;
  }
  @Input() public get secondaryActionName(): string {
    return this._secondaryActionName;
  }
  public set secondaryActionName(value: string) {
    if (this.componentRef) {
      this.componentRef.secondaryActionName = value;
    }
    this._secondaryActionName = value;
  }

  @Input() public get thirdActionName(): string {
    return this._thirdActionName;
  }
  public set thirdActionName(value: string) {
    if (this.componentRef) {
      this.componentRef.thirdActionName = value;
    }
    this._thirdActionName = value;
  }
  @Input() public get fourthActionName(): string {
    return this._fourthActionName;
  }
  public set fourthActionName(value: string) {
    if (this.componentRef) {
      this.componentRef.fourthActionName = value;
    }
    this._fourthActionName = value;
  }
  @Input()
  get description() {
    return this._description;
  }
  set description(data) {
    if (this.componentRef) {
      this.componentRef.description = data;
    }
    this._description = data;
  }
  @Input()
  get colorBar() {
    return this._colorBar;
  }
  set colorBar(data) {
    if (this.componentRef) {
      this.componentRef.colorBar = data;
    }
    this._colorBar = data;
  }

  @Input()
  get leftIconPath() {
    return this._leftIconPath;
  }
  set leftIconPath(data) {
    if (this.componentRef) {
      this.componentRef.leftIconPath = data;
    }
    this._leftIconPath = data;
  }

  @Input()
  get image() {
    return this._image;
  }
  set image(data) {
    if (this.componentRef) {
      this.componentRef.image = data;
    }
    this._image = data;
  }

  @Input()
  get shortHand() {
    return this._shortHand;
  }
  set shortHand(data) {
    if (this.componentRef) {
      this.componentRef.shortHand = data;
    }
    this._shortHand = data;
  }

  constructor(private abcComponentService: AbcComponentService) {
    this.style = ComponentStyle.Material;
    this.rtlEnabled = this.abcComponentService.rtlEnabled;
  }

  ngOnInit() {
    this.setCardsAttributesIfAvailable();
    this.createComponentInstance().subscribe((component) => {
      this.eventListener.forEach((element) => {
        component.addEventListener(element.type, element.listener);
      });
    });
  }

  ngAfterViewInit() {
    this.abcComponentService.addInstance(this);
  }

  ngOnDestroy(): void {
    this.eventListener = [];
    this.abcComponentService.removeInstance(this);
  }

  setCardsAttributesIfAvailable() {
    if (this.id) {
      const style: CardStyle = {
        height: this._height,
        width: this._width,
      };
      this.htmlAttributes = {
        id: this.id,
        displayText: this.displayText,
        secondaryDisplayText: this.secondaryDisplayText,
        icon: this.icon,
        image: this.image,
        colorBar: this.colorBar,
        leftIconPath: this.leftIconPath,
        description: this.description,
        shortHand: this.shortHand,
        primaryActionName: this.primaryActionName,
        secondaryActionName: this.secondaryActionName,
        thirdActionName: this.thirdActionName,
        fourthActionName: this.fourthActionName,
        rightIconSize: this.rightIconSize,
        leftIconPosition: this.leftIconPosition,
        rightIsImg: this.rightIsImg,
        leftIconSize: this.leftIconSize,
        leftIsImg: this.leftIsImg,
        rightIconPath: this.rightIconPath,
        template: this.template,
        defaultImg: this.defaultImg,
        searchInput: this.searchInput,
        headerDescription: this.headerDescription,
        disabledTooltip: this.disabledTooltip,
        class: this.class,
        buttons: this.buttons,
        setCardStyle: (_cardStyle: CardStyle) => (_cardStyle = style),
        setCustomDataAttributes: (dataAttr: Object) => {
          this.componentRef.setCustomDataAttributes(dataAttr);
          // To do...
        },
      };
    }
  }

  createComponentInstance(): Observable<any> {
    const observable = new Observable((observer) => {
      // let componentRef: any;
      switch (this.style) {
        case ComponentStyle.Material: {
          this.componentRef = this.abcComponentService.loadComponent(
            MatCardComponent,
            this.viewContainerRef,
          ).componentRef.instance;
          this.componentRef.onCardClick?.subscribe?.(() => {
            this.cardClick();
          });
          this.componentRef.onCardDblClick?.subscribe?.(() => {
            this.cardDblClick();
          });
          this.componentRef.onPrimaryActionClick?.subscribe?.(() => {
            this.primaryActionClick();
          });
          this.componentRef.onSecondaryActionClick?.subscribe?.(() => {
            this.secondaryActionClick();
          });
          this.componentRef.onThirdActionClick?.subscribe?.(() => {
            this.thirdActionClick();
          });
          this.componentRef.onFourthActionClick?.subscribe?.(() => {
            this.fourthActionClick();
          });
          break;
        }
      }

      if (this.htmlAttributes.id) this.componentRef.id = this.htmlAttributes.id;
      if (this.htmlAttributes.displayText) this.componentRef.displayText = this.htmlAttributes.displayText;
      if (this.htmlAttributes.secondaryDisplayText)
        this.componentRef.secondaryDisplayText = this.htmlAttributes.secondaryDisplayText;
      if (this.htmlAttributes.icon) this.componentRef.icon = this.htmlAttributes.icon;
      if (this.htmlAttributes.image) this.componentRef.image = this.htmlAttributes.image;
      if (this.htmlAttributes.colorBar) this.componentRef.colorBar = this.htmlAttributes.colorBar;
      if (this.htmlAttributes.leftIconPath) this.componentRef.leftIconPath = this.htmlAttributes.leftIconPath;
      if (this.htmlAttributes.searchInput) this.componentRef.searchInput = this.htmlAttributes.searchInput;
      if (this.htmlAttributes.description) this.componentRef.description = this.htmlAttributes.description;
      if (this.htmlAttributes.shortHand) this.componentRef.shortHand = this.htmlAttributes.shortHand;
      if (this.htmlAttributes.primaryActionName)
        this.componentRef.primaryActionName = this.htmlAttributes.primaryActionName;
      if (this.htmlAttributes.secondaryActionName)
        this.componentRef.secondaryActionName = this.htmlAttributes.secondaryActionName;
      if (this.htmlAttributes.thirdActionName) this.componentRef.thirdActionName = this.htmlAttributes.thirdActionName;
      if (this.htmlAttributes.fourthActionName)
        this.componentRef.fourthActionName = this.htmlAttributes.fourthActionName;
      if (this.htmlAttributes.rightIconPath) this.componentRef.rightIconPath = this.htmlAttributes.rightIconPath;
      if (this.htmlAttributes.rightIconSize) this.componentRef.rightIconSize = this.htmlAttributes.rightIconSize;
      this.componentRef.rightIsImg = this.htmlAttributes.rightIsImg ?? false;
      this.componentRef.leftIsImg = this.htmlAttributes.leftIsImg ?? false;
      this.componentRef.rtlEnabled = this.rtlEnabled ? 'rtl' : 'auto';
      if (this.htmlAttributes.template) this.componentRef.template = this.htmlAttributes.template;
      if (this.htmlAttributes.defaultImg) this.componentRef.defaultImg = this.htmlAttributes.defaultImg;
      if (this.htmlAttributes.leftIconSize) this.componentRef.leftIconSize = this.htmlAttributes.leftIconSize;
      if (this.htmlAttributes.leftIconPosition)
        this.componentRef.leftIconPosition = this.htmlAttributes.leftIconPosition;
      this.componentRef.headerDescription = this.htmlAttributes.headerDescription ?? false;
      this.componentRef.disabledTooltip = this.htmlAttributes.disabledTooltip ?? false;
      if (this.htmlAttributes.class) this.componentRef.class = this.htmlAttributes.class;
      if (this.buttons) this.componentRef.buttons = this.buttons;
      this.componentRef.setCardStyle(this.htmlAttributes.setCardStyle());
      observer.next(this.componentRef);
    });
    return observable;
  }

  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions,
  ): void {
    this.eventListener.push({ type, listener });
  }

  private cardClick(): void {
    this.onCardClick.emit();
  }
  private cardDblClick(): void {
    this.onCardDblClick.emit();
  }

  private primaryActionClick() {
    this.onPrimaryActionClick.emit();
  }

  private secondaryActionClick() {
    this.onSecondaryActionClick.emit();
  }

  private thirdActionClick() {
    this.onThirdActionClick.emit();
  }

  private fourthActionClick() {
    this.onFourthActionClick.emit();
  }
}
